<div class="label" (click)="onLabelClicked()">
    <span [style.color]="labelColor">{{label}}</span>
    <span class="percentage">{{percentage | percentage}}</span>
</div>
